import React, { useMemo } from 'react';
import { Grid, Typography } from '@mui/material';
import { ImageAndText } from '../../atoms/ImageAndText';
import { colors } from '../../utils/theme';
import {
  PRODUCT_CODE_MAPPING,
  PRODUCT_SLUG_MAPPING,
  ROOTINE_WEB_URL,
} from '../../config';
import { useGlobalState } from '../../utils/GlobalStateProvider';

export const CarouselUpsellSection = (): JSX.Element => {
  const context = useGlobalState(true);

  const testBundlePrice = useMemo(() => {
    if (context.state.products.size > 0) {
      return context.state.products.get(PRODUCT_CODE_MAPPING.three_test_bundle)
        ?.price;
    }
  }, [context.state.products]);
  return (
    // TODO: Add custom carousel
    <Grid
      sx={{
        py: 12,
        px: { xs: 3, md: 0 },
        borderBottom: `1px solid ${colors.greys.BORDER_GREY}`,
      }}
    >
      <ImageAndText
        imgSrc="/images/blood_mineral_&_vitamin_test.png"
        imgAlt="Rootine's blood mineral and vitamin test bundle"
        imgFit="contain"
        subtitle1="VITAMIN TEST"
        subtitle2="MINERAL TEST"
        title="Recommend at-home lab test: Vitamin and Mineral Test"
        description={
          <Grid container flexDirection="column">
            <Typography fontSize={24} variant="light" sx={{ mt: 4, mb: 3 }}>
              Our at-home vitamin and mineral tests help uncover micronutrient
              insufficiencies and guide your custom formula for your daily Smart
              Multivitamin.
            </Typography>

            <Typography fontSize={24} variant="light" sx={{ mb: 1 }}>
              Vitamin and Mineral tests address distinct symptoms and concerns:
            </Typography>
            <ul>
              <li>
                <Typography fontSize={20} variant="light">
                  Low vitamin levels may lead to fatigue, brain fog, digestive
                  issues, poor sleep, headaches, and more.
                </Typography>
              </li>
              <li style={{ marginBottom: 12, marginTop: 12 }}>
                <Typography fontSize={20} variant="light">
                  Inadequate mineral levels can result in nausea, high blood
                  pressure, hormonal imbalance, skin issues, thyroid problems,
                  fertility concerns, and more.
                </Typography>
              </li>
            </ul>
            <Typography fontSize={24} variant="light" sx={{ mb: 4 }}>
              With each test, we tailor your personalized multivitamin to ensure
              you receive the precise nutrients for your body.
            </Typography>
          </Grid>
        }
        primaryButton={{
          label: testBundlePrice
            ? `Add to cart - $${testBundlePrice.toFixed(2)}`
            : 'Add to cart',
          url: `${ROOTINE_WEB_URL}/collections/${PRODUCT_SLUG_MAPPING.at_home_test_collection}`,
          ariaLabel: 'Buy the Vitamin and Mineral Test now',
        }}
        reverseLayout
      />
    </Grid>
  );
};
